/**
 * Utilidades para el manejo de menús y funcionalidades "Nuevo"
 */

/**
 * Verifica si un elemento del menú debe mostrar el chip "Nuevo"
 * basado en las fechas de lanzamiento y fin
 * @param fechaLanzamiento - Fecha de inicio para mostrar como "Nuevo" (formato: YYYY-MM-DD)
 * @param fechaFin - Fecha de fin para dejar de mostrar como "Nuevo" (formato: YYYY-MM-DD)
 * @returns true si el elemento debe mostrar el chip "Nuevo"
 */
export const isMenuItemNew = (fechaLanzamiento?: string, fechaFin?: string): boolean => {
  if (!fechaLanzamiento) return false;

  const currentDate = new Date();
  const launchDate = new Date(fechaLanzamiento);

  // Verificar que la fecha de lanzamiento haya pasado
  if (currentDate < launchDate) return false;

  // Si hay fecha de fin, verificar que no haya pasado
  if (fechaFin) {
    const endDate = new Date(fechaFin);
    if (currentDate > endDate) return false;
  }

  return true;
};

/**
 * Obtiene el texto del chip basado en el tipo de novedad
 * @param fechaLanzamiento - Fecha de lanzamiento
 * @param fechaFin - Fecha de fin
 * @returns El texto del chip a mostrar
 */
export const getNewChipText = (fechaLanzamiento?: string, fechaFin?: string): string => {
  if (!fechaLanzamiento) return '';
  return 'Nuevo';
};

/**
 * Obtiene el color del chip basado en la antigüedad del lanzamiento
 * @param fechaLanzamiento - Fecha de lanzamiento
 * @returns Un objeto con los colores del chip
 */
export const getNewChipColors = (fechaLanzamiento?: string) => {
  if (!fechaLanzamiento) return { bg: '#1976d2', color: '#fff' };

  // const currentDate = new Date();
  // const launchDate = new Date(fechaLanzamiento);
  // const diffTime = currentDate.getTime() - launchDate.getTime();
  // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Nuevo (primera semana) - Verde brillante

  return { bg: '#4caf50', color: '#fff' };
};
